<template lang="html">
  <v-card>
    <v-card-text class="pa-0">
      <v-layout
        align-center
        ma-0
      >
        <v-sheet
          class="v-sheet--offset ml-5 pa-5 shrink"
          :color="color"
          style="top:-32px"
          elevation="8"
          max-width="72"
        >
          <v-icon
            color="white"
            large
          >
            {{ icon }}
          </v-icon>
        </v-sheet>
        <v-spacer />
        <v-flex
          shrink
          text-right
          pa-4
        >
          <div class="display-2">
            <SiTweenNumber
              :value="internalValue"
              :format="format"
              :decimals="decimals"
            />
          </div>

          <div class="body-1">
            {{ label }}
          </div>
        </v-flex>
      </v-layout>
      <template v-if="subLabel">
        <v-divider />
        <v-flex pa-3>
          <v-layout
            ma-0
            align-center
          >
            <v-flex
              pa-0
              text-right
              v-html="subLabel"
            />
          </v-layout>
        </v-flex>
      </template>
      <template v-if="monthBar">
        <v-divider />
        <v-flex pa-3>
          <v-layout
            ma-0
            align-center
          >
            <v-icon
              v-if="monthBar.mtdGrow"
              color="success"
            >
              trending_up
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              trending_down
            </v-icon>
            <v-spacer />
            MTD: <strong class="ml-1 mr-3">{{ format(monthBar.mtd) }}</strong>
            LAST:<strong class="ml-1 ">
              {{ format(monthBar.mtdLast) }}/{{ format(monthBar.mLast) }}
            </strong>
            <!-- <v-icon small class="ml-1" :color="monthBar.mtdGrow ? 'success' : 'error'">{{monthBar.mtdGrow ? 'arrow_upward' : 'arrow_downward'}}</v-icon> -->
            <!-- <span class="error--text" :class="{'success--text': monthBar.mtdGrow}">{{monthBar.mtdPercent}}%</span> -->
            <v-icon
              small
              class="ml-1"
              :color="monthBar.mtdGrow ? 'success' : 'error'"
            >
              {{ monthBar.mtdGrow ? 'arrow_upward' : 'arrow_downward' }}
            </v-icon>
            <span
              class="error--text"
              :class="{'success--text': monthBar.mtdGrow}"
            >{{ monthBar.mtdPercent }}%</span>
            /
            <v-icon
              small
              class="1"
              :color="monthBar.mLastGrow ? 'success' : 'error'"
            >
              {{ monthBar.mLastGrow ? 'arrow_upward' : 'arrow_downward' }}
            </v-icon>
            <span
              class="error--text"
              :class="{'success--text': monthBar.mLastGrow}"
            >{{ monthBar.mLastPercent }}%</span>
          </v-layout>
        </v-flex>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    value: Number,
    label: String,
    format: {
      type: Function,
      default: v => v
    },
    decimals: Number,
    icon: String,
    color: String,
    monthBar: Object,
    subLabel: String
  },
  computed: {
    internalValue () {
      return this.value ? this.value : 0
    }
  }
}
</script>

<style lang="css" scoped>

</style>
